module.exports = __webpack_public_path__ + "static/enjoy-logo-38633dfd0b73fa4ff64c2b90a5d52196.png";